import React from 'react';
import { CustomModal } from './CustomModal';

export const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message }) => {
    if (!isOpen) return null;
    return (
       <CustomModal isOpen={isOpen} onClose={onClose} title={title} maxWidth="max-w-md">
           <div className="space-y-4">
               <p>{message}</p>
               <div className="flex justify-end gap-3 pt-4">
                   <button type="button" onClick={onClose} className="py-2 px-5 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">Hủy</button>
                   <button type="button" onClick={onConfirm} className="py-2 px-5 bg-red-600 text-white rounded-lg hover:bg-red-700">Xác nhận</button>
               </div>
           </div>
       </CustomModal>
     );
   };